(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-qk-upsell-root]";
  var INPUT_SELECTOR = "input[data-qk-upsell-item]";
  var CARD_SELECTOR = "[data-qk-upsell-card]";
  var CARD_TRIGGER_SELECTOR = "[data-qk-upsell-trigger]";
  var TOGGLE_SELECTOR = "[data-qk-upsell-toggle]";
  var INIT_ATTR = "data-qk-upsell-initialized";

  function parseInteger(value, fallback) {
    var parsed = Number.parseInt(String(value == null ? "" : value), 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function toTruthy(value) {
    var normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "1" || normalized === "true" || normalized === "yes" || normalized === "on";
  }

  function cssEscape(value) {
    if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
      return CSS.escape(String(value));
    }

    return String(value).replace(/[^a-zA-Z0-9_-]/g, "\\$&");
  }

  function formatMoney(cents, format) {
    var formatString = String(format || window.themeVariables?.settings?.moneyFormat || "${{amount}}");
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");

      if (isNaN(number) || number == null) {
        return "0";
      }

      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split(".");
      var amount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var decimals = parts[1] ? decimal + parts[1] : "";

      return amount + decimals;
    }

    var match = formatString.match(placeholderRegex);
    var token = match && match[1] ? match[1] : "amount";
    var value;

    switch (token) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function resolveAssociatedControl(form, predicate) {
    if (!(form instanceof HTMLFormElement) || typeof predicate !== "function") {
      return null;
    }

    var directControls = Array.from(form.elements || []);
    for (var i = 0; i < directControls.length; i += 1) {
      if (predicate(directControls[i])) {
        return directControls[i];
      }
    }

    var formId = String(form.id || "").trim();
    if (!formId) {
      return null;
    }

    var escapedId = cssEscape(formId);
    var associated = document.querySelectorAll("[form=\"" + escapedId + "\"]");
    for (var j = 0; j < associated.length; j += 1) {
      if (predicate(associated[j])) {
        return associated[j];
      }
    }

    return null;
  }

  function resolveQuantityInput(form) {
    return resolveAssociatedControl(form, function (control) {
      return (
        control instanceof HTMLInputElement &&
        control.name === "quantity" &&
        control.type !== "hidden" &&
        !control.disabled
      );
    });
  }

  function resolveParentQuantity(quantityInput) {
    if (!(quantityInput instanceof HTMLInputElement)) {
      return 1;
    }

    var fallbackValue = parseInteger(quantityInput.defaultValue, 1);
    var value = parseInteger(quantityInput.value, fallbackValue);
    return Math.max(1, value);
  }

  function unique(values) {
    var seen = new Set();
    return values.filter(function (value) {
      var normalized = String(value == null ? "" : value).trim();
      if (!normalized || seen.has(normalized)) {
        return false;
      }

      seen.add(normalized);
      return true;
    });
  }

  function clampDiscountPercent(value) {
    var parsed = parseInteger(value, 0);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return 0;
    }

    return Math.max(0, Math.min(100, parsed));
  }

  function resolveResponsiveValue(root, mobileAttr, desktopAttr, mobileFallback, desktopFallback) {
    var isDesktop = typeof window.matchMedia === "function"
      ? window.matchMedia("(min-width: 1000px)").matches
      : window.innerWidth >= 1000;
    var attr = isDesktop ? desktopAttr : mobileAttr;
    var fallback = isDesktop ? desktopFallback : mobileFallback;
    return Math.max(1, parseInteger(root.getAttribute(attr), fallback));
  }

  function syncCardPressedState(root) {
    var inputs = Array.from(root.querySelectorAll(INPUT_SELECTOR));
    inputs.forEach(function (input) {
      if (!(input instanceof HTMLInputElement)) {
        return;
      }

      var trigger = input.nextElementSibling;
      if (!(trigger instanceof HTMLElement) || !trigger.matches(CARD_TRIGGER_SELECTOR)) {
        return;
      }

      trigger.setAttribute("aria-pressed", input.checked ? "true" : "false");
    });
  }

  function createCollapseController(root) {
    var cards = Array.from(root.querySelectorAll(CARD_SELECTOR));
    var actions = root.querySelector("[data-qk-upsell-actions]");
    var toggle = root.querySelector(TOGGLE_SELECTOR);
    var viewMoreLabel = String(root.getAttribute("data-qk-upsell-view-more-label") || "Vezi mai mult").trim();
    var viewLessLabel = String(root.getAttribute("data-qk-upsell-view-less-label") || "Vezi mai putin").trim();
    var expanded = false;
    var resizeTick = 0;

    if (!cards.length) {
      return {
        update: function () {}
      };
    }

    if (!viewMoreLabel) {
      viewMoreLabel = "Vezi mai mult";
    }

    if (!viewLessLabel) {
      viewLessLabel = "Vezi mai putin";
    }

    var update = function () {
      var columns = resolveResponsiveValue(
        root,
        "data-qk-upsell-columns-mobile",
        "data-qk-upsell-columns-desktop",
        3,
        6
      );
      var maxRows = resolveResponsiveValue(
        root,
        "data-qk-upsell-max-rows-mobile",
        "data-qk-upsell-max-rows-desktop",
        2,
        2
      );
      var maxVisibleItems = Math.max(1, columns * maxRows);
      var hasOverflow = cards.length > maxVisibleItems;

      if (!hasOverflow) {
        expanded = false;
      }

      cards.forEach(function (card, index) {
        if (!(card instanceof HTMLElement)) {
          return;
        }

        card.hidden = hasOverflow && !expanded ? index >= maxVisibleItems : false;
      });

      if (actions instanceof HTMLElement) {
        actions.hidden = !hasOverflow;
      }

      if (toggle instanceof HTMLElement) {
        toggle.setAttribute("aria-expanded", hasOverflow && expanded ? "true" : "false");
        toggle.textContent = hasOverflow && expanded ? viewLessLabel : viewMoreLabel;
      }
    };

    if (toggle instanceof HTMLButtonElement) {
      toggle.addEventListener("click", function () {
        expanded = !expanded;
        update();
      });
    }

    window.addEventListener(
      "resize",
      function () {
        if (resizeTick) {
          cancelAnimationFrame(resizeTick);
        }

        resizeTick = requestAnimationFrame(function () {
          resizeTick = 0;
          update();
        });
      },
      { passive: true }
    );

    return { update: update };
  }

  function initUpsellRoot(root) {
    if (!(root instanceof HTMLElement)) {
      return;
    }

    if (root.getAttribute(INIT_ATTR) === "1") {
      return;
    }

    var formId = String(root.getAttribute("data-form-id") || "").trim();
    if (!formId) {
      return;
    }

    var form = document.getElementById(formId);
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    root.setAttribute(INIT_ATTR, "1");

    var matchParentQuantity = toTruthy(root.getAttribute("data-match-parent-quantity"));
    var autoDiscountEnabled = toTruthy(root.getAttribute("data-qk-upsell-auto-discount-enabled"));
    var autoDiscountPercent = autoDiscountEnabled
      ? clampDiscountPercent(root.getAttribute("data-qk-upsell-auto-discount-percent"))
      : 0;
    var moneyFormat = String(root.getAttribute("data-money-format") || "");
    if (moneyFormat.indexOf("<") !== -1) {
      moneyFormat = moneyFormat.replace(/<[^>]*>/g, "").trim();
    }

    var quantityInput = resolveQuantityInput(form);
    var countElement = root.querySelector("[data-qk-upsell-count]");
    var totalElement = root.querySelector("[data-qk-upsell-total]");
    var selectedElement = root.querySelector("[data-qk-upsell-selected]");
    var liveElement = root.querySelector("[data-qk-upsell-live]");
    var collapseController = createCollapseController(root);

    root.addEventListener("click", function (event) {
      var target = event && event.target instanceof Element ? event.target : null;
      var trigger = target ? target.closest(CARD_TRIGGER_SELECTOR) : null;

      if (!(trigger instanceof HTMLButtonElement) || !root.contains(trigger)) {
        return;
      }

      var inputId = String(trigger.getAttribute("data-qk-upsell-input-id") || "").trim();
      if (!inputId) {
        return;
      }

      var input = root.querySelector("#" + cssEscape(inputId));
      if (!(input instanceof HTMLInputElement) || input.disabled) {
        return;
      }

      input.checked = !input.checked;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });

    var recalculate = function () {
      var selectedInputs = Array.from(root.querySelectorAll(INPUT_SELECTOR + ":checked:not([disabled])"));
      var parentQuantity = matchParentQuantity ? resolveParentQuantity(quantityInput) : 1;

      var totalCents = selectedInputs.reduce(function (sum, input) {
        var unitPriceCents = Math.max(0, parseInteger(input.getAttribute("data-qk-upsell-price"), 0));
        var effectiveUnitPriceCents = unitPriceCents;
        if (autoDiscountPercent > 0) {
          effectiveUnitPriceCents = Math.max(
            0,
            Math.round((unitPriceCents * (100 - autoDiscountPercent)) / 100),
          );
        }

        return sum + effectiveUnitPriceCents * parentQuantity;
      }, 0);

      var selectedTitles = unique(selectedInputs.map(function (input) {
        return input.getAttribute("data-qk-upsell-title");
      }));

      if (countElement instanceof HTMLElement) {
        countElement.textContent = String(selectedInputs.length);
      }

      if (totalElement instanceof HTMLElement) {
        totalElement.textContent = formatMoney(totalCents, moneyFormat);
      }

      if (selectedElement instanceof HTMLElement) {
        selectedElement.hidden = selectedTitles.length === 0;
        selectedElement.textContent = selectedTitles.length
          ? "Selectate: " + selectedTitles.join(", ")
          : "";
      }

      if (liveElement instanceof HTMLElement) {
        var discountMessage = autoDiscountPercent > 0
          ? " cu " + autoDiscountPercent + "% reducere aplicata."
          : ".";

        liveElement.textContent = selectedInputs.length
          ? selectedInputs.length + " extra selectate. Total extra " + formatMoney(totalCents, moneyFormat) + discountMessage
          : "Nu ai selectat produse extra.";
      }

      syncCardPressedState(root);
    };

    root.addEventListener("change", function (event) {
      var target = event && event.target instanceof HTMLInputElement ? event.target : null;
      if (!(target instanceof HTMLInputElement) || !target.matches(INPUT_SELECTOR)) {
        return;
      }

      recalculate();
    });

    if (matchParentQuantity && quantityInput instanceof HTMLInputElement) {
      quantityInput.addEventListener("input", recalculate);
      quantityInput.addEventListener("change", recalculate);
    }

    form.addEventListener("variant:change", recalculate);
    collapseController.update();
    recalculate();
  }

  function init(scope) {
    var root = scope instanceof Element || scope instanceof Document ? scope : document;
    var nodes = Array.from(root.querySelectorAll(ROOT_SELECTOR));
    nodes.forEach(initUpsellRoot);
  }

  function bindEvents() {
    document.addEventListener("shopify:section:load", function (event) {
      init(event.target);
    });

    if (typeof MutationObserver !== "undefined") {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) {
              return;
            }

            if (node.matches(ROOT_SELECTOR)) {
              initUpsellRoot(node);
            } else if (node.querySelector(ROOT_SELECTOR)) {
              init(node);
            }
          });
        });
      });

      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
      bindEvents();
    });
  } else {
    init(document);
    bindEvents();
  }
})();
